export default "__VITE_ASSET__e64a3ed8__"